/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CollapsableCommentLocal = {
    readonly collapsedCommentSettings: {
        readonly commentIDs: ReadonlyArray<string>;
    } | null;
    readonly " $refType": "CollapsableCommentLocal";
};
export type CollapsableCommentLocal$data = CollapsableCommentLocal;
export type CollapsableCommentLocal$key = {
    readonly " $data"?: CollapsableCommentLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"CollapsableCommentLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CollapsableCommentLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CollapsedCommentSettings",
                    "kind": "LinkedField",
                    "name": "collapsedCommentSettings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentIDs",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '636fded12e5fab6ac8ddef6db34714da';
export default node;
